module.exports = [
    { value: 'sort_date desc',   label: 'Sortierdatum' },
    { value: 'title', label: 'Titel' },
    { value: 'airdate desc', label: 'Ausstrahlungsdatum' },
];
